import { Link } from 'react-router-dom'

import { UsersIcon, Button } from '@buffer-mono/popcorn'
import {
  BufferTrackerReact as BufferTracker,
  Product,
} from '@buffer-mono/tracking-plan'

import {
  useAccount,
  useCanStartTrial,
  useOrganizationId,
} from '~publish/contexts/AccountContext'
import { MODALS, useOpenGlobalModal } from '~publish/hooks/useOpenGlobalModal'
import { isTeamPlan } from '~publish/pages/Settings/Billing/utils/planUtils'

import type { JSX } from 'react'

function TeamMemberInviteUpgradeCTA(): JSX.Element | null {
  const { account } = useAccount()
  const organizationId = useOrganizationId()
  const canStartTrial = useCanStartTrial()
  const openGlobalModal = useOpenGlobalModal()
  const isTeam = account && isTeamPlan(account)

  const cta = 'publish-allChannels-inviteTeam-1'
  const commonTrackingProperties =
    account?.currentOrganization?.commonTrackingProperties || null

  const handleUpgradePathClick = (): void => {
    if (canStartTrial) {
      openGlobalModal(MODALS.startTrial, {
        cta,
        upgradePathName: 'inviteTeam-trial',
      })
    } else {
      openGlobalModal(MODALS.planSelector, {
        cta,
        upgradePathName: 'inviteTeam-upgrade',
      })
    }
    BufferTracker.cTAClicked({
      organizationId: organizationId ?? '',
      product: Product.Publish,
      cta,
      clientName: 'publishWeb',
      upgradePathName: `inviteTeam-${canStartTrial ? 'trial' : 'upgrade'}`,
      ...commonTrackingProperties,
    })
  }

  if (isTeam) {
    return (
      <Button variant="secondary" size="medium" as={Link} to="/settings/team">
        <UsersIcon /> Invite your Team
      </Button>
    )
  }

  return (
    <Button variant="secondary" size="medium" onClick={handleUpgradePathClick}>
      <UsersIcon /> Invite Your Team
    </Button>
  )
}

export default TeamMemberInviteUpgradeCTA
